module.exports = __webpack_public_path__ + "33edc1901b5562ece473f5855771bf65.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/return-unread.svg
// module id = 115
// module chunks = 0